import { setAsyncData } from '../core';

import { DashboardAction } from './actions';
import { DashboardState } from './types';

const initialState: DashboardState = {
  visitsOverview: {},
};

export function dashboardReducer(state: DashboardState = initialState, action: DashboardAction): DashboardState {
  switch (action.type) {
    case 'DASHBOARD_SET_VISIT_OVERVIEW_IS_FETCHING':
      return {
        ...state,
        visitsOverview: {
          ...state.visitsOverview,
          [action.data.date]: setAsyncData(state.visitsOverview[action.data.date] || { isFetching: false }, (p) => (p.isFetching = action.data.value)),
        },
      };

    case 'DASHBOARD_SET_VISIT_OVERVIEW':
      return {
        ...state,
        visitsOverview: {
          ...state.visitsOverview,
          [action.data.date]: setAsyncData(state.visitsOverview[action.data.date] || { isFetching: false }, (p) => (p.data = action.data.value)),
        },
      };

    default:
      return state;
  }
}
